module.exports = __webpack_public_path__ + "siteBanner_img_op.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/temp/siteBanner_img_op.jpg?v=3
// module id = 1862
// module chunks = 0